//Please add the language resource
const carrierDp = {
  addrCode: 'addrCode',
  addrName: 'addrName',
  carrierNo: 'carrierNo',
  carrierName: 'carrierName',
  region: 'region',
  companyName: 'companyName',
  useCompanyName: 'useCompanyName',
  provinceCode: 'provinceCode',
  provinceName: 'provinceName',
  cityCode: 'cityCode',
  cityName: 'cityName',
  districtCode: 'districtCode',
  districtName: 'districtName',
  addr: 'addr',
  lat: 'lat',
  lng: 'lng',
  contactMan: 'contactMan',
  contactWay: 'contactWay',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
};
export default carrierDp



// WEBPACK FOOTER //
// ./src/page/mdm/carrierDp/lang/carrierDp.en.js